/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function (Flickity) {
  // Add custom code below this line

  gsap.registerPlugin(ScrollTrigger);


  let tl = gsap.timeline();

  tl.fromTo(
    ".header__logo svg",
    {

      y: "80%",
      width: "40vw",
      duration: 0,
      ease: "power1.inOut",
    },
    {
      scrollTrigger: {
        trigger: ".header-sections",
        start: "start start",
        end: "+=400 15%",
        scrub: true,
      },

      width: "100%",
      y: 0,
      duration: 3,
      ease: "power1.inOut",
    }
  );

  try {
    const lenis = new Lenis();
    lenis.on("scroll", ScrollTrigger.update);
    gsap.ticker.add(time => lenis.raf(time * 1000));
    gsap.ticker.lagSmoothing(0);
  } catch (err) {
    console.error("Lenis failed to initialize:", err);
  }

  // FR Accordion Images
  const accordionElems = document.querySelectorAll(
    ".fr-section--double .accordion"
  );

  const checkActive = (accordionImages, imageLeft) => {
    accordionImages.forEach((img) => {
      if (!img.classList.contains("is-active")) {
        gsap.to(img, {
          left: imageLeft ? "100%" : "-100%",
          duration: 0.5,
          ease: "power2.inOut",
        });
      }
    });
  };

  const checkActiveAccordion = (accordion, accordionImages) => {
    const noOpenAttribute = !accordion.hasAttribute("open");

    if (noOpenAttribute) {
      //console.log("No accordion is open.");
      accordionImages.forEach((img) => img.classList.remove("is-active"));
      accordionImages[0].classList.add("is-active");
    }
  };

  accordionElems.forEach((accordion) => {
    const brickSection = accordion.closest(".brick__section");
    const accordionImages = brickSection.querySelectorAll(
      ".brick__block__image"
    );
    const imageLeft = brickSection.classList.contains(
      "brick__section--reversed"
    );

    accordion.addEventListener("click", () => {
      const dataIndex = accordion.getAttribute("data-accordion-index");
      //console.log(dataIndex);

      let matchFound = false;
      accordionImages.forEach((img) => {
        if (img.getAttribute("data-accordion-index") === dataIndex) {
          matchFound = true;
        }
      });

      const activeIndex = matchFound ? dataIndex : "1";

      accordionImages.forEach((img) => {
        img.classList.toggle(
          "is-active",
          img.getAttribute("data-accordion-index") === activeIndex
        );
      });

      checkActiveAccordion(accordion, accordionImages);
    });
  });

  const testimonialsEnabledElements = document.querySelectorAll(
    ".testimonials-content.animation-enabled"
  );

  const checkAnimationClass = () => {
    let animationEnabled = false;
    testimonialsEnabledElements.forEach((element) => {
      if (element.classList.contains("animation-enabled")) {
        animationEnabled = true;
      } else {
        return false;
      }
    });
  };

  const splitLines = (element, nonSelected) => {
    let textToSplit = element;
    if (textToSplit) {
      gsap.to(textToSplit, {
        backgroundPosition: "left top -25%",
        duration: 1.4,
        ease: "power2.inOut",
      });
    }
  };

  let testimonials = new Flickity(".testimonials", {
    cellAlign: "left",
    contain: true,
    imagesLoaded: true,
    prevNextButtons: false,
    pageDots: false,
    wrapAround: true,
    autoPlay: 5000,
    pauseAutoPlayOnHover: false,
  });

  testimonials.on("change", (idx, i) => {
    //console.log("change", idx, i);

    const selectedTestimonial = testimonials.selectedElement;
    let nonSelected = [];
    const textToSplit = selectedTestimonial.querySelectorAll("blockquote");
    if (textToSplit) {
    }
  });

  window.addEventListener("load", (event) => {
    testimonials.resize();
  });
})(themeVendor.Flickity);
